// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2WwuN","right":"Footer_right__36iIf","buttons":"Footer_buttons__3vOal"};